module.exports = __webpack_public_path__ + "static/media/somos2.8a56ddbe.png";